<script>
    import Drawer from '@fno/component/layout/Drawer.svelte'
    import TabMenu from './TabMenu.svelte'
    import { Button } from 'sveltestrap'
    import Icon from 'svelte-awesome'
    import { bars } from 'svelte-awesome/icons'
    import { currentSchool } from '@fno/service/api/schools.js'


    export let asr
    export let schoolId
    export let portalConfig
    export let featureFlags
    export let tabTool

    const { stepIdToRoute } = $currentSchool

    let open
    let scrim
    let staticAssetPrefix = (window.fanxVersion && window.fanxVersion.urlPrefix) || '/'
    let windowLocationPath = window.location.pathname

    let modalDialog

    function handleOpenDialog() {
            modalDialog.openModal()
    }
</script>

<style>
    div[slot='panel'] {
        min-height: 100%;
    }
    /*
    NOTE: This is a hack to override the Bootstrap 3 styles, which were
    causing the navbar to be centered (using the old clear/float trick).
    Once we are off 3, or if we've managed to silo 3 away by itself more
    carefully, we can ditch these.
    */
    div[slot='content'] :global(nav.navbar div.container-fluid:before) {
        display: initial !important;
        content: initial !important;
    }
    div[slot='content'] :global(nav.navbar div.container-fluid:after) {
        display: initial !important;
        content: initial !important;
        clear: initial !important;
    }

    :global(html) {
        background-color: #f2f2f2 !important;
    }

    :global(.fno-onboarding-menu) {
        background-color: #00838A !important;
        color: #fff;
    }

    :global(.fno-onboarding-menu a) {
        color: #fff;
        font-weight: bold;
    }
</style>

<Drawer bind:open bind:scrim bgColor="#00838A" fontColor="#fff">
    <div slot="panel">
        <TabMenu 
            {asr} 
            {schoolId} 
            {handleOpenDialog} 
            {featureFlags}
            {portalConfig}
            {stepIdToRoute}
            {tabTool}
        />
    </div>
    <div slot="content" class="bg-light-color">
        {#if !open || scrim}
            <nav class="navbar" id="navbarNav">
                <div class="container-fluid">
                    <a class="navbar-brand" href={windowLocationPath}>
                        <img
                            src="{staticAssetPrefix}img/snap-fanx.png"
                            alt="Snap! Mobile"
                            height="54"
                            class="d-inline-block align-top"
                        />
                    </a>
                    <Button on:click={() => (open = true)}>
                        <Icon data={bars} />
                    </Button>
                </div>
            </nav>
        {/if}
        <div class="container px-0">
            <uiView />
        </div>
    </div>
</Drawer>